import List from '@mui/joy/List'
import ListItem from '@mui/joy/ListItem'
import ListItemButton, { listItemButtonClasses } from '@mui/joy/ListItemButton'
import ListItemContent from '@mui/joy/ListItemContent'
import Typography from '@mui/joy/Typography'
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom'
import { closeSidebar, isPathSelected } from './utils'
import DevicesRoundedIcon from '@mui/icons-material/DevicesRounded'
import MessageIcon from '@mui/icons-material/Message'
import LaptopChromebookRoundedIcon from '@mui/icons-material/LaptopChromebookRounded'
import { User, useUser } from 'api/users'
import {
    useIntegrationList,
    useIntegrationMessages,
} from 'api/chat-api-integration'
import { MessagesRequestProps } from 'types/dataManagement'
import { useGeneral } from 'context/General'

type Props = {
    user: User | null
}

const ChatApiLinks = ({ user }: Props) => {
    const location = useLocation()
    const { pathname } = location

    const workspaceId = user?.access?.workspaceId
    const userId = user?.access?.internalUserId

    const { from, to } = useGeneral()

    const { data: integrationList, isLoading } = useIntegrationList({
        workspaceId: workspaceId,
        userId: userId,
        limit: 25,
        page: 1,
    })

    const objectsMessagesReqProps: MessagesRequestProps = {
        filters: [],
        query: '*',
        workspaceId: workspaceId!,
        limit: 25,
        startDateTime: from,
        endDateTime: to,
    }

    const {
        data: messagesList,
        isLoading: isLoadingMessages,
        isIdle,
        isFetching,
        isError: isErrorMessages,
    } = useIntegrationMessages(objectsMessagesReqProps)
    return (
        <List
            size="sm"
            sx={{
                gap: 1,
                '--List-nestedInsetStart': '30px',
                '--ListItem-radius': (theme) => theme.vars.radius.sm,
            }}
        >
            <ListItem>
                <ListItemButton
                    selected={isPathSelected(pathname, '/integrations')}
                    role="menuitem"
                    component={RouterLink}
                    to="/integrations"
                >
                    <DevicesRoundedIcon />
                    <ListItemContent>
                        <Typography level="title-sm">
                            Integrations{' '}
                            {integrationList?.length
                                ? `[${integrationList.length}]`
                                : null}
                        </Typography>
                    </ListItemContent>
                </ListItemButton>
            </ListItem>

            <ListItem>
                <ListItemButton
                    selected={isPathSelected(pathname, '/messages')}
                    role="menuitem"
                    component={RouterLink}
                    to="/messages"
                >
                    <MessageIcon />
                    <ListItemContent>
                        <Typography level="title-sm">
                            Messages{' '}
                            {messagesList?.messages?.length
                                ? `[${messagesList.itemsCount}]`
                                : null}
                        </Typography>
                    </ListItemContent>
                </ListItemButton>
            </ListItem>
            <ListItem>
                <ListItemButton
                    selected={isPathSelected(pathname, '/playground')}
                    role="menuitem"
                    component={RouterLink}
                    to="/playground"
                >
                    <LaptopChromebookRoundedIcon />
                    <ListItemContent>
                        <Typography level="title-sm">API Playground</Typography>
                    </ListItemContent>
                </ListItemButton>
            </ListItem>
        </List>
    )
}

export default ChatApiLinks
